import React from 'react'
import loadable from '@loadable/component'
import PlickersCardSVG from './PlickersCardSVG'

const CartoonScreenSVG = loadable(() => import(/*webpackChunkName: 'cartoonscreenSVG'*/ './CartoonScreenSVG'))


class CartoonDevice extends React.Component{


	
 	render() { 	
   	
   	switch (this.props.device) {
     
     case 'iPhone':
     return (
	    <div className='cartoonDevice cartoonDevice--iPhone'>

	    	<div className='cartoonDevice--iPhone-topSensors'>
	    		<svg className="cartoonDevice--iPhone-topSensors-svg" width="427" height="66" viewBox="0 0 427 66" xmlns="http://www.w3.org/2000/svg">  	    				    		
					  <g fillRule="evenodd">
					    <rect width="74" height="7" x="176" y="54" fill="#F1F1F1" rx="3.5"/>
					    <circle cx="213" cy="29" r="5" fill="#F1F1F1"/>
					    <circle cx="145.5" cy="57.5" r="7.5" fill="#F1F1F1"/>
					  </g>
					</svg>
	    	</div>
	    	
	    	<div className='cartoonDevice-screen'>
	    		<CartoonScreenSVG screen={this.props.screen} />
	    	</div>

	    	<div className='cartoonDevice-body' />

	    	{this.props.showContactShadow &&
    			<div className='cartoonDevice-contactShadow' />	    			    		
    		}
	    	
	    </div>
		 )


		case 'laptop':
     return (
	    <div className='cartoonDevice cartoonDevice--laptop'>
	    
	    	<div className='cartoonDevice-screen'>	    		
	    		<CartoonScreenSVG screen={this.props.screen} />
	    	</div>

	    	<div className='cartoonDevice--laptop-base'>	    		
	    	</div>
	    	
	    </div>
		 )


		case 'android':
     return (
	    <div className='cartoonDevice cartoonDevice--android'>

	   
	    	<div className='cartoonDevice--android-topSensors'>
	    		<svg className="cartoonDevice--android-topSensors-svg" width="228" height="16" viewBox="0 0 228 16" xmlns="http://www.w3.org/2000/svg">
					  <g fill="none" fillRule="evenodd" transform="translate(-83 -12)">
					    <rect width="63" height="9" x="166" y="16" fill="#EDEDED" rx="2"/>
					    <circle cx="91" cy="20" r="8" fill="#F5F5F5"/>
					    <circle cx="303" cy="20" r="8" fill="#F5F5F5"/>
					    <circle cx="118" cy="20" r="5" fill="#EDEDED"/>
					    <circle cx="276" cy="20" r="5" fill="#EDEDED"/>
					  </g>
					</svg>
	    	</div>
	    	
	    	<div className='cartoonDevice-screen'>
	    		<CartoonScreenSVG screen={this.props.screen} />
	    	</div>

	    	<div className='cartoonDevice-body' />

	    	{this.props.showContactShadow &&
	    		<div className='cartoonDevice-contactShadow' />	    			    		
	    	}
	    	
	    </div>
		 )

    case 'card':
     return (
	    <div className='cartoonDevice cartoonDevice--card'>
	    	
	    	<div className='cartoonDevice--card-plickersCard'>	    		
	    		<PlickersCardSVG cardExample={this.props.cardExample} />
	    	</div>	    		    
	    	
	    </div>
		 )

   	default:
    return null;
 		}
 	}
}



export default CartoonDevice


